import { memo } from 'react';

import {
  Box,
  Card,
  CardActionArea,
  Skeleton,
  Stack,
  useTheme,
} from '@mui/material';

type ComparableListingsSkeletonProps = {
  variant?: 'horizontal' | 'vertical';
};

const ComparableListingsSkeleton = ({
  variant = 'vertical',
}: ComparableListingsSkeletonProps) => {
  const theme = useTheme();

  if (variant === 'horizontal') {
    return (
      <Card sx={{ display: 'flex', overflow: 'hidden' }}>
        <Box
          sx={{
            width: { xs: '120px', sm: '200px' },
            position: 'relative',
          }}
        >
          <Skeleton
            variant="rectangular"
            sx={{
              height: '100%',
              width: '100%',
              minHeight: '140px',
              background: (theme.vars ?? theme).palette.grey[200],
            }}
          />
        </Box>
        <Box sx={{ p: 1, pl: 2, flexGrow: 1 }}>
          <Stack spacing={1} sx={{ width: '100%' }}>
            <Skeleton variant="rounded" height={16} width="40%" />
            <Stack direction="row" spacing={1}>
              <Skeleton variant="rounded" width={60} height={14} />
              <Skeleton variant="rounded" width={40} height={14} />
            </Stack>
            <Skeleton variant="rounded" width="60%" height={18} />
            <Stack direction="row" spacing={1}>
              <Skeleton variant="rounded" width={80} height={14} />
              <Skeleton variant="rounded" width={120} height={14} />
            </Stack>
            <Skeleton variant="rounded" width="30%" height={22} />
          </Stack>
        </Box>
      </Card>
    );
  }

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Skeleton
        variant="rectangular"
        sx={{
          height: '200px',
          width: '100%',
          background: (theme.vars ?? theme).palette.grey[200],
        }}
      />
      <CardActionArea sx={{ flexGrow: 1 }}>
        <Stack
          direction="column"
          sx={{
            flex: '1',
          }}
        >
          <Box
            sx={{
              p: 2,
            }}
          >
            <Stack spacing={1}>
              <Skeleton variant="rounded" height={16} />
              <Stack direction="row" spacing={1}>
                <Skeleton variant="rounded" width={100} height={14} />
                <Skeleton variant="rounded" width={80} height={14} />
              </Stack>
              <Skeleton variant="rounded" width="50%" height={22} />
              <Skeleton variant="rounded" width="40%" height={16} />
            </Stack>
          </Box>
        </Stack>
      </CardActionArea>
    </Card>
  );
};

export default memo(ComparableListingsSkeleton);
